import moment from 'moment';

// Constants.
import * as ReportBloodPressureConstants from 'constants/ReportBloodPressureConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  records: [],
  dataUser: {},
  // ...window.__initialState__?.reportBloodPressure ?? {},
};

export default function reportBloodPressure(state = initialState, action = {}) {
  switch (action.type) {
    case ReportBloodPressureConstants.LOAD_REPORT_BLOOD_PRESSURE_REQUEST:
    case ReportBloodPressureConstants.LOAD_MORE_REPORT_BLOOD_PRESSURE_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ReportBloodPressureConstants.LOAD_REPORT_BLOOD_PRESSURE_SUCCESS: {
      const records = action.records.sort((a, b) => {
        if (moment(a.date).isSame(b.date, 'day')) {
          return 0;
        }
        else if (a.date > b.date) {
          return -1
        }
        else {
          return 1;
        }
      });
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        records: records,
        dataUser: action.dataUser,
      };
    }
    case ReportBloodPressureConstants.LOAD_MORE_REPORT_BLOOD_PRESSURE_SUCCESS: {
      const records = action.records.sort((a, b) => {
        if (moment(a.date).isSame(b.date, 'day')) {
          return 0;
        }
        else if (a.date > b.date) {
          return -1
        }
        else {
          return 1;
        }
      });
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        records: records,
      };
    }
    case ReportBloodPressureConstants.LOAD_REPORT_BLOOD_PRESSURE_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        records: [],
        dataUser: {},
      };
    default: {
      return state;
    }
  }
}
